import React, {Component} from 'react';
import { Link } from 'react-router-dom'
import './IndustriesCard.css';

export default class IndustriesCard extends Component {
	constructor(props) {
		super(props);
	}

	render() {

		return (
			<Link className="industries_link" to={this.props.link} onClick={this.props.click} >
			<div className="industries_card_container" style={{backgroundImage: `url(${this.props.image})`}}>
				<div className="industries_card_container_cover">
					<div className="industries_card_content">
						<div className="industries_card_logo" style={{backgroundImage: `url(${this.props.logo})`}}></div>
						<div className="industries_card_title">
							<span>{this.props.industry}</span>
						</div>
					</div>
				</div>
			</div>

			</Link>

		)
	}
};
